import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoSidebarLeftClosed16 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M12.7344 1.00006C13.985 1.00027 14.9989 2.01409 14.999 3.26471V12.7335C14.9988 13.984 13.985 14.9979 12.7344 14.9981H3.26562C2.01501 14.998 1.00119 13.9841 1.00098 12.7335V3.26471C1.00111 2.01404 2.01495 1.0002 3.26562 1.00006H12.7344ZM6.2832 13.4981H12.7344C13.1565 13.4979 13.4988 13.1556 13.499 12.7335V3.26471C13.4989 2.84251 13.1566 2.50027 12.7344 2.50006H6.2832V13.4981Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoSidebarLeftClosed16;